module.exports = __webpack_public_path__ + "static/media/chevron_left_green.9481d092.svg";